export default {
  methods: {
    openGallery(galleryId, file) {
      // check if gallery can be opened
      if (!file || !file?.antivir_ok || file?.deleted || (file?.antivir_pending === false && !file?.antivir_tested)) {
        return
      }

      this.$router.push({
        path: this.$route.path + '/gallery', 
        query: { 
          gallery: galleryId,
          file: file?.id
        } 
      })
    }
  }
}
